import { DomSanitizer } from '@angular/platform-browser';
import { Injectable, SecurityContext } from '@angular/core';
import Swal from 'sweetalert2';

const FORBIDDEN_KEYS = ['code', 'locked', 'locked_time'];

@Injectable({
  providedIn: 'root',
})
export class SweetAlertService {
  private alert = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
  });

  constructor(private sanitizer: DomSanitizer) {}

  formatKeyMessage(key: string, message: string): string {
    return !FORBIDDEN_KEYS.includes(key) ? message : '';
  }

  convertObjectToString(
    object: { [index: string]: any },
    key: string,
    msg = ''
  ): string {
    if (typeof object[key] === 'string') {
      return this.formatKeyMessage(key, object[key]);
    }
    if (Array.isArray(object[key])) {
      return (msg +=
        this.formatKeyMessage(
          key,
          object[key].map((err, index) => {
            const objectKeys = Object.keys(err);
            if (objectKeys.length && typeof err !== 'string') {
              return objectKeys.map((objKey) =>
                this.convertObjectToString(err, objKey, `${index}: `)
              );
            }
            return err;
          })
        ) + '\n');
    }
    return (msg += Object.keys(object[key])
      .map((errKey) => this.convertObjectToString(object[key], errKey, msg))
      .join('\n'));
  }

  toast({
    type,
    msg = '',
    error,
  }: {
    type: 'error' | 'success' | 'warning' | 'info';
    msg?: string;
    error?: { [index: string]: string[] } | unknown[];
  }): void {
    if (Array.isArray(error)) {
      msg = error
        .map((e) => {
          return Object.keys(e)
            .map((key) => {
              if (typeof e[key] === 'string') {
                return this.formatKeyMessage(key, e[key]);
              }

              if (!Array.isArray(e[key])) {
                return this.convertObjectToString(e, key);
              }
              return e[key].map((err) =>
                typeof err === 'string'
                  ? this.formatKeyMessage(key, err)
                  : Object.keys(err)?.map((keyN) => {
                      return this.convertObjectToString(err, keyN);
                    })
              );
            })
            .join('\n');
        })
        .join('\n');
    } else if (typeof error === 'object') {
      msg += Object.keys(error)
        .map((key) => {
          if (!Array.isArray(error[key])) {
            return this.convertObjectToString(error, key);
          }
          return error[key]
            .filter((err) => Object.keys(err).length)
            .map((err) =>
              typeof err === 'string'
                ? this.formatKeyMessage(key, err)
                : Object.keys(err)?.map((keyN) => {
                    return this.convertObjectToString(err, keyN);
                  })
            );
        })
        .join('\n');
    } else if (typeof error === 'string') {
      msg += error;
    }

    this.alert
      .fire({
        icon: type,
        title: this.sanitizer.sanitize(
          SecurityContext.HTML,
          msg || 'Server error.'
        ),
      })
      .then((result) => {
        return result;
      });
  }
}
